// extracted by mini-css-extract-plugin
export default {"popup":"paidSessionPopup_popup__3u60C","content":"paidSessionPopup_content__GihKG","aboveText":"paidSessionPopup_aboveText__B3NXv","whiteBtn":"paidSessionPopup_whiteBtn__eD5G8"};